import { DressCode } from '@withjoy/joykit/icons';
import React from 'react';
import { ScheduleSection } from '../ScheduleSection';
import { FieldMetadata } from '@shared/components/ScheduleEditor/hooks/useScheduleFormState';
import { ScheduleEditorData } from '@shared/components/ScheduleEditor/types';
import { DateSelection } from '@withjoy/joykit';
import { useTranslation } from '@shared/core/i18n';
import { FormTextField } from '../FormTextField';

type DressCodeSectionProps = {
  state: ScheduleEditorData;
  setValue: (key: keyof ScheduleEditorData, value: string | DateSelection) => void;
  meta: Record<keyof ScheduleEditorData, FieldMetadata>;
};

export const DressCodeSection = (props: DressCodeSectionProps) => {
  const { state, setValue, meta } = props;
  // Use initial data to determine whether event is start/end/tba

  const { t } = useTranslation('scheduleEditor');
  const trans = t('form');

  return (
    <ScheduleSection
      icon={<DressCode size={24} />}
      title={trans.dressCodeTitle()}
    >
      <FormTextField
        maxLength={140}
        fieldName={'dressCode'}
        state={state}
        setValue={setValue}
        placeholder={trans.dressCodePlaceholder()}
        meta={meta}
      />
    </ScheduleSection>
  );
};
